import LightBulb from '../src/LightBulb/index';
export default LightBulb;
